/**
 * Implements MyPositions based on covalent api
 */
import { useSelector } from 'react-redux';
import { IStore } from '../../../reducers';
import useWalletTrades from '../useWalletTrades';
import useCollectTickers from '../useCollectTickers';
import MyPositionsTable from './Table';
import MyPositionsTableMobile from './TableMobile';
import { Network } from '@kattana-io/common';
import { useAccount } from 'wagmi';

export interface IMyPositionsSelector {
  base: string;
  quote: string;
  base_decimals: number;
  quote_decimals: number;
  flipped: boolean;
  network: string;
  address: string;
  txUrl: string;
}

const selector = (state: IStore): IMyPositionsSelector => {
  const [base, quote] = state.current.name.split('/');
  return {
    base,
    quote,
    flipped: state.current.flipped,
    base_decimals: state.current.base_decimals,
    quote_decimals: state.current.quote_decimals,
    network: state.current.chain,
    address: state.current.address,
    txUrl: Network.fromChain(state.current.chain)?.getScan() || '',
  };
};

interface IMyPositionProps {
  width?: number;
  isMobile?: boolean;
}

/**
 * Data-layer wrapper
 * @param param0
 * @returns
 */
const MyPositionsDataLayer = ({ width, isMobile }: IMyPositionProps) => {
  const { address: account } = useAccount();
  const state = useSelector(selector);
  const {
    base,
    base_decimals,
    quote_decimals,
    network,
    address,
    quote,
    flipped,
    txUrl,
  } = state;
  const { swaps, loading } = useWalletTrades(account, network, address);
  const { tickers, loadingTickers } = useCollectTickers(swaps);

  const openTx = (tx: string) => window.open(`${txUrl}${tx}`);

  return isMobile ? (
    <MyPositionsTableMobile
      {...state}
      base={base}
      base_decimals={base_decimals}
      quote={quote}
      quote_decimals={quote_decimals}
      flipped={flipped}
      tickers={tickers}
      trades={swaps}
      openTx={openTx}
      loading={loading || loadingTickers}
    />
  ) : (
    <MyPositionsTable
      {...state}
      base={base}
      base_decimals={base_decimals}
      quote={quote}
      quote_decimals={quote_decimals}
      flipped={flipped}
      tickers={tickers}
      trades={swaps}
      openTx={openTx}
      loading={loading || loadingTickers}
      width={width}
    />
  );
};

export default MyPositionsDataLayer;
